import { render, staticRenderFns } from "./settings-organization-fonts.vue?vue&type=template&id=3f53d014&scoped=true&"
import script from "./settings-organization-fonts.vue?vue&type=script&lang=js&"
export * from "./settings-organization-fonts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f53d014",
  null
  
)

export default component.exports